export const personalInfo = {
  name: 'Ryan Fonseca',
  title: 'Développeur Fullstack',
  email: 'fonseca.ryan69100@gmail.com',
  phone: '07 45 35 23 07',
  phoneFormatted: '07 45 35 23 07',
  location: 'Lyon 5ème, 69005',
  linkedin: 'https://www.linkedin.com/in/ryan-fonseca-3a73b2302/',
  github: 'https://github.com/rf69100',
  initials: 'RF',
  tagline:
    'Étudiant BTS SIO SLAM • Recherche alternance Bachelor Developpeur Fullstack / licence pro DevOps 2026',
};
